import type {
  CreateReviewInput,
  ReviewMutationResult,
  UpdateReviewInput,
} from '@repo/api-contracts';
import { useInvalidateReviews } from '@/entities/review';
import { trpc } from '@/shared/api';

/** 후기 작성·수정 뮤테이션 — 성공하면 후기 관련 조회를 무효화한다. 상품 id 를 모르면 요약 전체를 무효화한다. */
export const useSaveReview = () => {
  const invalidate = useInvalidateReviews();
  const createMutation = trpc.myReviews.create.useMutation();
  const updateMutation = trpc.myReviews.update.useMutation();
  return {
    create: async (input: CreateReviewInput, productId?: string): Promise<ReviewMutationResult> => {
      const result = await createMutation.mutateAsync(input);
      await invalidate.afterWrite(productId);
      return result;
    },
    update: async (input: UpdateReviewInput, productId: string): Promise<ReviewMutationResult> => {
      const result = await updateMutation.mutateAsync(input);
      await invalidate.afterWrite(productId);
      return result;
    },
    isPending: createMutation.isPending || updateMutation.isPending,
  };
};
